module.exports = __webpack_public_path__ + "/static/assets/f1852e923ae3adbc8eea353f6a1e4712.png";